import React, { useContext } from 'react';
import { Button, ButtonElevation, ButtonType } from '@prisjakt/ui/button';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { getFractalRepresentation } from './utils';
import { VariantSelectionCallback } from './types';
import { SelectionButtonText } from './styles';
import { Behavior } from '@prisjakt/ui/text';

export const SizeVariantSelectionButton: React.FC<IVariantSelectionButton> = props => {
  const { variant, title, handleSelection } = props;
  const { selectedSizeVariants } = useContext(PriceListFilterContext);
  const sizeWithFractal = getFractalRepresentation(title);

  const isSelected = Boolean(
    (variant && selectedSizeVariants?.includes(variant)) ||
      (!variant && !selectedSizeVariants)
  );

  const onSelect = () => handleSelection(variant);

  return (
    <Button
      onClick={onSelect}
      selectable
      selected={isSelected}
      fullWidth
      type={ButtonType.OUTLINED}
      elevation={ButtonElevation.NONE}
    >
      <SelectionButtonText behavior={Behavior.OnelineEllipsis}>
        {sizeWithFractal}
      </SelectionButtonText>
    </Button>
  );
};

interface IVariantSelectionButton {
  variant: string | null;
  title: string;
  handleSelection: VariantSelectionCallback;
}
